import { firebaseDB, firebaseFunctions } from 'utils/firebase';
import {
	getDoc,
	doc,
	query,
	collection,
	getDocs,
	where,
	updateDoc,
	getDocFromCache,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { updateEmail } from 'firebase/auth';

const COLLECTION_NAME = 'users';

const updateUserEmail = async (currentUser, email) => {
	await updateEmail(currentUser, email);

	const userRef = doc(firebaseDB, COLLECTION_NAME, currentUser.uid);
	const res = await updateDoc(userRef, { email });
	return res;
};

const addNewUserAndCompany = async (userUid, user, company) => {
	const createNewUserAndCompany = httpsCallable(firebaseFunctions, 'createNewUserAndCompany');
	const res = await createNewUserAndCompany({ userUid, user, company });
	return res;
};

const updateUserData = async (userUid, userData) => {
	if (!userUid) return null;
	if (!userData) return null;

	// Filter out the company obj which is just a local cache
	const { company, ...persistedUserData } = userData;

	const userRef = doc(firebaseDB, COLLECTION_NAME, userUid);
	const res = await updateDoc(userRef, persistedUserData);

	return res;
};

const getUser = async id => {
	if (!id) return null;
	const docObj = doc(firebaseDB, COLLECTION_NAME, id);
	const defaultData = {
		language: 'de',
	};
	let data = null;

	// try a cached query first
	try {
		const snap = await getDocFromCache(docObj);
		if (snap.exists()) {
			data = snap.data();
		}
	} catch (e) {
		const snap = await getDoc(docObj);
		if (snap.exists()) {
			data = snap.data();
		}
	}

	if (data) {
		// apply defaults
		if (!data.language) {
			data.language = defaultData.language;
		}
		return data;
	}

	return null;
};

const getUsersFromCompany = async companyId => {
	if (!companyId) return null;

	const companyUsersQuery = query(
		collection(firebaseDB, COLLECTION_NAME),
		where('companyId', '==', companyId)
	);

	const querySnapshot = await getDocs(companyUsersQuery);

	const res = [];

	querySnapshot.forEach(docSnap => {
		res.push(docSnap.data());
	});

	return res;
};

const USERS_API = {
	addNewUserAndCompany,
	updateUserData,
	updateUserEmail,
	getUser,
	getUsersFromCompany,
};

export default USERS_API;
